interface Props {
  rows?: number;
  columns?: number;
}

const CARD_CLASS =
  'rounded-[12px] border border-[color:var(--nq-line)] bg-[color:var(--nq-surface-card)] px-[18px] py-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]';

const SKELETON = 'block rounded-[4px] bg-white/[0.06] animate-pulse';

const ComparisonPerformanceTableSkeleton = ({
  rows = 3,
  columns = 6,
}: Props) => {
  const gridCols = `minmax(120px, 1.4fr) repeat(${Math.max(columns - 1, 1)}, minmax(0, 1fr))`;

  return (
    <div className={CARD_CLASS} aria-busy="true">
      <div className="mb-3 flex flex-col">
        <div className={`${SKELETON} mb-2 h-[18px] w-[220px]`} />
        <div className={`${SKELETON} h-3 w-[min(420px,85%)]`} />
      </div>
      <div className="flex flex-col gap-2.5 pt-1">
        <div
          className="grid items-center gap-3"
          style={{ gridTemplateColumns: gridCols }}
        >
          {Array.from({ length: columns }).map((_, i) => (
            <div
              key={i}
              className={`${SKELETON} h-2.5 opacity-70`}
              style={{ width: i === 0 ? '72%' : undefined }}
            />
          ))}
        </div>
        {Array.from({ length: rows }).map((_, row) => (
          <div
            key={row}
            className="grid items-center gap-3"
            style={{ gridTemplateColumns: gridCols }}
          >
            {Array.from({ length: columns }).map((_, col) => (
              <div
                key={col}
                className={`${SKELETON} h-3.5`}
                style={{
                  width:
                    col === 0 ? '72%' : col === columns - 1 ? '40%' : '55%',
                }}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComparisonPerformanceTableSkeleton;
